/**
 * Copyright © 2026 Arberia Experience. Tutti i diritti riservati.
 * Riproduzione, distribuzione o uso non autorizzato di questo codice
 * protetto da diritto d'autore sono severamente vietati.
 */
export const Gamification = {
    // Definizione soglie XP (Crescita esponenziale)
    // Level 1: 0-99
    // Level 2: 100
    // Formula: XP = 100 * (Level-1)^1.5  (APPROX)
    // Actually user requested: 100 * Math.pow(level, 1.5) as "Required XP for Level"

    getRequiredXP: (level) => Math.floor(100 * Math.pow(level, 1.5)),

    // Calculate level based on total XP
    getLevelFromXP: (currentXP) => {
        let level = 1;
        while (currentXP >= Gamification.getRequiredXP(level + 1)) {
            level++;
        }
        return level;
    },

    // Calcolo percentuale progresso per la barra UX
    getProgressToNextLevel: (currentXP) => {
        const currentLevel = Gamification.getLevelFromXP(currentXP);
        const currentLevelXP = Gamification.getRequiredXP(currentLevel);
        const nextLevelXP = Gamification.getRequiredXP(currentLevel + 1);

        let progress = 0;
        if (nextLevelXP > currentLevelXP) {
            progress = ((currentXP - currentLevelXP) / (nextLevelXP - currentLevelXP)) * 100;
        }

        return Math.min(Math.max(progress, 0), 100);
    },

    // Get stats for UI
    getStats: (currentXP) => {
        const level = Gamification.getLevelFromXP(currentXP);
        const nextXp = Gamification.getRequiredXP(level + 1);
        const currentLevelBase = Gamification.getRequiredXP(level);

        return {
            level,
            currentXP,
            nextLevelXP: nextXp,
            progressPercent: Gamification.getProgressToNextLevel(currentXP),
            xpForNextLevel: nextXp - currentXP
        };
    }
};
